// extracted by mini-css-extract-plugin
export default {"container":"BasicTooltip_container__rmEm4","title":"BasicTooltip_title__97Gm2"};